export const SHIPMENT_PAYMENT_OPTION = "paymentMethod";
export const PACKAGE_SIZE_OPTION_MOBILE = "packageSizeMobile";
export const PACKAGE_SIZE_OPTION_DESKTOP = "packageSizeDesktop";
export const PACKAGE_SIZE_OPTION_NAME = "packageSizeName";
